<script setup>
import selectToken from "@/components/dashboard/selectToken.vue";
import { ref } from "@vue/reactivity";
import getCookie from "@/scripts/utils/getCookie.js";
import { payWithETH, payWithERC20 } from "../../scripts/dashboard_functs/token_purchase/payInTokens";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Papa from "papaparse"
import { onMounted } from "vue";
const requests = ref(null);
const tokenVal = ref(null);
const store = useStore();
const form = ref(null);
const route = useRoute();
const downloadLink = ref(null);
const showDownloadBtn = ref(null);
const downloadTitle = ref(null);

onMounted(() => {
    fetch(`/api/org/${route.query.org}/credits/quotes`)
        .then((r) => r.json()).then((data) => {
            const purchaseData = data.offers.filter(item => item.status === "filled").map(item => ({
                txhash: item.txhash,
                requests: item.requests,
                paymentAddress: item.paymentAddress
            }))
            
                store.state.creditOffers = purchaseData;
                const csvdata = Papa.unparse(store.state.creditOffers);
                const blob = new Blob([csvdata], { type: 'text/csv' });
                downloadLink.value = URL.createObjectURL(blob);
            if (!purchaseData.length) {
                console.info("No Purchase History")
            }
            else {
                showDownloadBtn.value = true;
            }
                 downloadTitle.value = `Rivet Credit Purchase History generated ${new Date().getTime()}`
            })
    
})

const submitRequests = () => {
    fetch(`/api/org/${route.query.org}/credits/quote`, {
        method: "POST",
        body: JSON.stringify({
            requests: parseInt(requests.value),
        }),
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": getCookie("csrftoken"),
        },
    })
        .then((res) => {
            return res.json();
        })
        .then((r) => {
            if (r.ok) {
                store.state.offer = r;
                switch (store.state.token_for_purchase) {
                    case "DAI":
                        tokenVal.value = `${store.state.offer.payload.tokenCost / 10 ** 18}`;
                        break;
                    case "ETH":
                        tokenVal.value = `${store.state.offer.payload.ethCost / 10 ** 18}`;
                        break;
                    default:
                        break;
                }
            }
        });
};

const handleTokenChange = () => {
    requests.value = "";
    tokenVal.value = "";
};

const submitToken = () => {
    switch (store.state.token_for_purchase) {
        case "ETH":
            fetch(`/api/org/${route.query.org}/credits/quote`, {
                method: "POST",
                body: JSON.stringify({
                    eth: tokenVal.value * 10 ** 18,
                }),
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": getCookie("csrftoken"),
                },
            })
                .then((res) => {
                    return res.json();
                })
                .then((r) => {
                    if (r.ok) {
                        store.state.offer = r;
                        requests.value = r.requests;
                    }
                })
                .catch((err) => console.log(err));
            break;
        case "DAI":
            fetch(`/api/org/${route.query.org}/credits/quote`, {
                method: "POST",
                body: JSON.stringify({
                    dai: tokenVal.value * 10 ** 18,
                }),
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": getCookie("csrftoken"),
                },
            })
                .then((res) => {
                    return res.json();
                })
                .then((r) => {
                    if (r.ok) {
                        store.state.offer = r;
                        requests.value = r.requests;
                    }
                })
                .catch((err) => console.log(err));
            break;
        default:
            break;
    }
};

const paymethod = () => {
    switch (store.state.token_for_purchase) {
        case "ETH":
            payWithETH(form.value);
            break;
        case "DAI":
            payWithERC20(form.value);
            break;
        default:
            break;
    }
};

</script>

<template>
    <div class="wrap dashboard_root flex_col">
        <header class="flex_col">
            <h2 class="ta_center">Buy Request Credits</h2>
        </header>
        <form ref="form" class="flex_col" @submit.prevent="paymethod">
            <selectToken @submitOnSelect="handleTokenChange" />
            <div class="input_req flex_col">
                <label for="requests"> Enter # of Requests </label>
                <input required @input="submitRequests" v-model="requests" name="requests" placeholder="100,000" type="number" />
            </div>
            <div>
                <label for="token"> Enter # of Tokens for purchase </label>
                <input type="text" v-model="tokenVal" @input="submitToken" name="token" />
                <span class="copy">{{ $store.state.token_for_purchase }}</span>
            </div>
            <div class="btn_long btn_color">
                <button type="submit">Pay in {{ $store.state.token_for_purchase }}</button>
            </div>
            <a v-if="showDownloadBtn" :download="downloadTitle"  :href="downloadLink" class="purchase_history">
              <p>Download Purchase History</p>
              <span><i class="ri-download-line"></i></span>
            </a>
        </form>
    </div>
</template>

<style lang="scss" scoped>
h2 {
    color: $offblack;
    padding: 0px;
}
form {
    padding: 2rem;
    background: light !important;
    width: 35rem;
    gap: 1.5rem;
    position: relative;
    border-radius: 1rem;
    margin: 0 auto;
    box-shadow: 1px 1px 14px 2px #e4e4e4;
    @include media("<=tablet") {
        width: 30rem;
    }
    @include media("<=phone-tab") {
        width: 95%;
    }
    @include media("<=phone") {
        width: 100%;
        padding: 1rem;
    }
    .input_req {
        gap: 0.5rem;
    }
    .select_t_q {
        select {
            background: $fadegrey;
            border: none;
            padding: 0.2rem 0;
        }
    }
    input {
        padding: 0.9rem 1rem;
        width: 100%;
        border-radius: 0.4rem;
        border: 1px solid grey;
    }
    .purchase_history{
        @include flex(center,center,.5rem);
        font-size: .9em;
        color: $blue;
        text-decoration: none;
        cursor: pointer;
        i{
            font-size: 1.2em;
        }
    }
}
</style>
